import {ref, Ref} from 'vue';

interface MarketplacePolyNodesControllerClassOptions {}

export class MarketplacePolyNodesControllerClass {
	private static _instance: MarketplacePolyNodesControllerClass;
	static instance() {
		return (this._instance = this._instance || new MarketplacePolyNodesControllerClass());
	}

	private _displayed: Ref<boolean> = ref(false);
	private constructor() {}

	displayed() {
		return this._displayed.value;
	}

	//
	// methods
	//
	async show(options: MarketplacePolyNodesControllerClassOptions = {}) {
		this._displayed.value = true;
	}
	close() {
		this._displayed.value = false;
	}
}

export const MarketplacePolyNodesController = MarketplacePolyNodesControllerClass.instance();
